import React, { useEffect, useState } from "react";

export default function Keypad({ usedKeys, handleKeyUpMobile }) {
  const [letters, setLetters] = useState(null);

  useEffect(() => {
    const json = [
      { key: "a" },
      { key: "b" },
      { key: "c" },
      { key: "d" },
      { key: "e" },
      { key: "f" },
      { key: "g" },
      { key: "h" },
      { key: "i" },
      { key: "j" },
      { key: "k" },
      { key: "l" },
      { key: "m" },
      { key: "n" },
      { key: "o" },
      { key: "p" },
      { key: "q" },
      { key: "r" },
      { key: "s" },
      { key: "t" },
      { key: "u" },
      { key: "v" },
      { key: "w" },
      { key: "x" },
      { key: "y" },
      { key: "z" },
      { key: "←" },
      { key: "↵" },
    ];
    setLetters(json);
  }, []);

  return (
    <div className="keypad">
      {letters &&
        letters.map((l) => {
          const color = usedKeys[l.key];
          return (
            <div
              id={l.key}
              key={l.key}
              className={color}
              onClick={(e) => {
                handleKeyUpMobile(e);
              }}
            >
              {l.key}
            </div>
          );
        })}
    </div>
  );
}
